module.exports = __webpack_public_path__ + "img/folios-icon-active.8ac73cf6.svg";